import Select from "react-select";

export default function AdminSelect({
  options = [],
  value,
  onChange,
  isMulti = false,
  placeholder = "Seleziona...",
  isSearchable = true,
  isDisabled = false,
   width = "200px"
}) {
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      minHeight: "50px",
      borderRadius: "12px",
      backgroundColor: "#f9f9fb",
      border: "none",
      boxShadow: state.isFocused
        ? "inset 2px 2px 6px rgba(0,0,0,0.12), inset -2px -2px 6px rgba(255,255,255,0.8)"
        : "inset 4px 4px 10px rgba(0,0,0,0.12), inset -4px -4px 10px rgba(255,255,255,0.8)",
      transition: "all 0.2s ease",
      padding: "2px 6px",
      opacity: state.isDisabled ? 0.5 : 1,

      "&:hover": {
        boxShadow:
          "inset 2px 2px 6px rgba(0,0,0,0.12), inset -2px -2px 6px rgba(255,255,255,0.8)"
      }
    }),

    valueContainer: (provided) => ({
      ...provided,
      padding: "0 10px"
    }),

    placeholder: (provided) => ({
      ...provided,
      color: "#b5b5b5",
      fontWeight: 400
    }),

    singleValue: (provided) => ({
      ...provided,
      color: "#393939",
      fontWeight: 500
    }),

    menu: (provided) => ({
      ...provided,
      marginTop: "8px",
      borderRadius: "12px",
      backgroundColor: "#f9f9fb",
      border: "none",
      boxShadow:
        "6px 6px 16px rgba(0,0,0,0.12), -6px -6px 16px rgba(255,255,255,0.8)",
      overflow: "hidden"
    }),

    menuList: (provided) => ({
      ...provided,
      padding: "6px"
    }),

    option: (provided, state) => ({
      ...provided,
      borderRadius: "10px",
      marginBottom: "4px",
      padding: "10px 12px",
      cursor: "pointer",
      transition: "all 0.15s ease",

      backgroundColor: state.isSelected
        ? "#cecdcd"
        : state.isFocused
        ? "#ececec"
        : "transparent",

      color: "#393939",
      fontWeight: state.isSelected ? 600 : 500
    }),

    indicatorSeparator: () => ({
      display: "none"
    }),

    dropdownIndicator: (provided) => ({
      ...provided,
      color: "#9ca3af",
      "&:hover": {
        color: "#393939"
      }
    }),

    container: (provided) => ({
      ...provided,
      minWidth: width || "auto"
    })
  };

  

  const theme = (theme) => ({
    ...theme,
    colors: {
      ...theme.colors,
      primary: "#cecdcd",
      primary25: "#ececec",
      primary50: "#cecdcd"
    }
  });

  return (
    <Select
      options={options}
      value={value}
      onChange={onChange}
      isMulti={isMulti}
      placeholder={placeholder}
      isSearchable={isSearchable}
      isDisabled={isDisabled}
      styles={customStyles}
      theme={theme}
      classNamePrefix="admin-select"
    />
  );
}